<template>
  <div class="image-viewer">
    <div class="image-viewer-pane" v-viewer="{ shown: () => handleViewerShown() }">
      <div
        class="preview-img"
        v-for="src in images"
        :style="{ background: 'url(' + src + ') no-repeat center center / 100%' }"
        :key="src"
      >
        <!-- pdf -->
        <div class="pdf-viewer" data-pdf="pdf" v-if="isPdf(src)">
          <pdf-viewer :pdf="src"></pdf-viewer>
        </div>

        <span class="view-btn iconfont el-icon-zoom-in">
          <img class="view-mask-img" :src="src" />
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import $util from '@/common/js/util';
import PdfViewer from '@/components/PdfViewer';

export default {
  name: 'DetailLicensePane',
  components: { PdfViewer },
  props: {
    images: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    // isPdf
    isPdf(url = '') {
      return /.(pdf)$/.test(url);
    },

    // 兼容pdf预览
    handleViewerShown() {
      const viewer = this.$el.querySelector('.image-viewer-pane').$viewer;
      const img = this.images[viewer.index] || '';
      const pdf = this.isPdf(img);

      if (pdf) {
        $util.openUrl(img, { newWin: true });
        viewer.hide();
      }
    }
  }
};
</script>
<style lang="less" scoped>
.image-viewer {
  .preview-img {
    display: inline-block;
    margin: 0 24px 24px 0;
    position: relative;
    width: 200px;
    height: 200px;
    overflow: hidden;
    border: 1px solid #ddd;

    &:hover {
      .view-btn,
      &::before {
        display: block;
      }
    }

    &::before {
      display: none;
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.2);
    }

    .view-btn {
      display: none;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 3;
      color: #fff;
      font-size: 30px;

      .view-mask-img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
        width: 100%;
        opacity: 0;
      }
    }

    .view-img {
      position: absolute;
      top: 0;
      width: 100%;
      left: 0;
    }
  }
}
</style>
